import * as React from "react";

import { Heading } from "~/components/ui/typography";
import { cn } from "~/lib/utils";

export function Page({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="page"
      className={cn(
        "flex w-full flex-col gap-9 px-5 pt-7 pb-16 sm:px-[30px] sm:pt-[26px] sm:pb-12",
        className,
      )}
      {...props}
    />
  );
}

export function PageHeader({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <header data-slot="page-header" className="flex max-w-[760px] flex-col gap-2">
      <h1 className="font-display text-[34px] leading-none font-medium tracking-[-0.035em] text-fg-strong">
        {title}
      </h1>
      {children ? (
        <p className="text-sm leading-normal text-pretty text-fg-muted">{children}</p>
      ) : null}
    </header>
  );
}

export function Section({
  title,
  description,
  action,
  children,
}: {
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section data-slot="section" className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <Heading>{title}</Heading>
          {description ? (
            <p className="mt-1.5 max-w-[640px] text-sm text-pretty text-fg-muted">
              {description}
            </p>
          ) : null}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
